import { ButtonIcon } from '@statsbomb/kitbag-components';
import { useSetAtom } from 'jotai';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { messageAwaitingApprovalActionsAtom } from '../../../atoms/messages';
import useApi, { API_ENDPOINTS } from '../../../hooks/api';
import Confirm from '../../Confirm';
import { removeVideoAwaitingApprovalAtom } from '../../../atoms/videoListings';

const DELETED_STATUS = 'DELETED';

export function DeleteVideo({ qaStatus, size, videoKey }) {
  const api = useApi();
  const intl = useIntl();

  const [displayConfirmation, setDisplayConfirmation] = useState(false);

  const setActionMessage = useSetAtom(messageAwaitingApprovalActionsAtom);
  const removeVideoAwaitingApproval = useSetAtom(
    removeVideoAwaitingApprovalAtom,
  );

  const handleClick = () => {
    setDisplayConfirmation(true);
  };

  const handleCancel = () => {
    setDisplayConfirmation(false);
  };

  const INITIATE_MESSAGE = intl.formatMessage(
    {
      defaultMessage: 'Delete {videoKey} initiated. Please wait...',
      id: '9b4bb',
    },
    { videoKey },
  );
  const SUCCESS_MESSAGE = intl.formatMessage(
    {
      defaultMessage: '{videoKey} deleted',
      id: 'c0d4d',
    },
    { videoKey },
  );
  const FAILURE_MESSAGE = intl.formatMessage(
    {
      defaultMessage: 'Delete {videoKey} failed',
      description: 'Delete Video Key Failed',
      id: '9cef9',
    },
    { videoKey },
  );

  const isDeleted = qaStatus === DELETED_STATUS;

  const deleteVideo = async () => {
    setDisplayConfirmation(false);
    setActionMessage(INITIATE_MESSAGE);

    const response = await api.delete(
      `${API_ENDPOINTS.videoService}/videos/${encodeURIComponent(videoKey)}`,
      { data: { private: false } },
    );

    if (response) {
      removeVideoAwaitingApproval(videoKey);
    }

    setActionMessage(response ? SUCCESS_MESSAGE : FAILURE_MESSAGE);
  };
  return (
    <>
      <ButtonIcon
        disabled={api.isFetching || isDeleted}
        icon="Delete"
        title={intl.formatMessage(
          {
            defaultMessage: 'Delete {videoKey}',
            description: 'Delete {videoKey}',
            id: '23366',
          },
          { videoKey },
        )}
        onClick={() => handleClick()}
        size={size}
        variant="secondary"
      />
      <Confirm
        id={`videoaction.delete.${videoKey}`}
        isOpen={displayConfirmation}
        onCancel={handleCancel}
        onConfirm={deleteVideo}
      >
        <FormattedMessage
          description="Delete Video Warning"
          defaultMessage="This will delete the {videoKey}. This action cannot be undone."
          id="85241"
          values={{ videoKey }}
        />
      </Confirm>
    </>
  );
}

DeleteVideo.propTypes = {
  qaStatus: PropTypes.string.isRequired,
  size: PropTypes.string,
  videoKey: PropTypes.string.isRequired,
};
DeleteVideo.defaultProps = {
  size: undefined,
};

export default { DeleteVideo };
